import { createSlice } from "@reduxjs/toolkit";

import { ActiveControlPanelModalState } from "@/features/ui/types";

interface ActiveModalState {
  activeModalState: ActiveControlPanelModalState;
}

const initialState: ActiveModalState = {
  activeModalState: {
    name: undefined,
    ids: [],
  },
};

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setActiveModal: (state, { payload }) => {
      const { name } = payload;
      state.activeModalState = {
        name,
        ids: payload.ids !== undefined ? [...payload.ids] : [],
      };
    },
    closeModal: (state) => {
      state.activeModalState = {
        name: undefined,
        ids: [],
      };
    },
  },
});

export const { setActiveModal, closeModal } = uiSlice.actions;

export default uiSlice.reducer;
